import { Card, CardContent } from "@/components/ui/card";
import { Star, Recycle, Shield, MapPin } from "lucide-react";

const WhyChooseSection = () => {
  const reasons = [
    {
      icon: Star,
      title: "Unmatched Expertise",
      description: "BBB Accredited with over 10 years transforming 500+ spaces. Trusted by Keller Williams and Michigan's luxury homes.",
    },
    {
      icon: Recycle,
      title: "Bespoke Solutions",
      description: "Custom luxury home organization and commercial designs that elevate your space.",
    },
    {
      icon: Shield,
      title: "Trusted by Clients",
      description: "\"Organize by Design created a professional, calming environment that our clients love!\" – Dr. Sarah L., West Hollywood, CA.",
    },
    {
      icon: MapPin,
      title: "White-Glove Service",
      description: "Stress-free, meticulous transformations with your vision at the heart.",
    },
  ];

  return (
    <section id="about" className="py-20 bg-background">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-serif font-light mb-6">
            Why Choose <span className="italic text-primary">Organize by Design</span>?
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            Your home or business deserves more than ordinary organization—it deserves artistry.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {reasons.map((reason, index) => (
            <Card key={index} className={`text-center border-border hover-lift fade-in-up stagger-${index + 1} bg-card`}>
              <CardContent className="p-8">
                <div className="inline-flex items-center justify-center w-16 h-16 bg-primary/10 rounded-full mb-6">
                  <reason.icon className="w-8 h-8 text-primary" />
                </div>
                <h3 className="text-lg font-semibold mb-4 text-balance">
                  {reason.title}
                </h3>
                <p className="text-muted-foreground text-sm leading-relaxed">
                  {reason.description}
                </p>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Call to Action */}
        <div className="text-center bg-primary/5 rounded-2xl p-12">
          <h3 className="text-2xl md:text-3xl font-serif font-medium mb-4">
            Ready to Transform Your Space?
          </h3>
          <p className="text-lg text-muted-foreground mb-6 max-w-2xl mx-auto">
            Join hundreds of satisfied clients who have transformed their homes and lives 
            with our professional organizing services.
          </p>
          <div className="flex flex-wrap justify-center gap-4 text-sm font-medium">
            <span className="bg-background px-4 py-2 rounded-full shadow-sm">🎯 Custom Plans</span>
            <span className="bg-background px-4 py-2 rounded-full shadow-sm">💡 Every Budget</span>
            <span className="bg-background px-4 py-2 rounded-full shadow-sm">🏠 Every Lifestyle</span>
            <span className="bg-background px-4 py-2 rounded-full shadow-sm">📐 Every Space</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseSection;